<template>
    <div>
        
        <div class="select mb-5" >
            <select v-model="grade_id" :disabled="loading==true" @change="getGradeCourses()">
                <option value="">Select grade</option>
                    <optgroup label="Nurse and CA Grades">
                        <option v-for="row in grades.filter(g => g.doctor != 1)" :key="row.id" :value="row.id">{{ row.name }}</option>
                    </optgroup>
                    <optgroup label="Doctor Grades">
                        <option v-for="row in grades.filter(g => g.doctor == 1)" :key="row.id" :value="row.id">{{ row.name }}</option>
                    </optgroup>
            </select>
            
        </div>

        

        <h4 class="title is-size-4">Courses Required For Selected Grade</h4>
        <div class="mb-4">
            <button class="button is-primary" @click="openAddModal()" :disabled="!grade_id || loading === true">Add Course</button>
        </div>

        <div class="notification is-warning" v-if="loading == true">
            Loading courses ...
        </div>
        <div class="notification is-danger" v-if="loading == false  && grade_courses.length == 0">
            No required courses can be found for that grade
        </div>

        <table class="table is-fullwidth is-hoverable " v-if="loading == false && this.grade_courses.length > 0">
            <thead>
                <tr>
                    <th>Course</th>
                    <th>Validity (months)</th>
                    
                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in this.grade_courses" :key="row.id" >
                    
                    <td>{{ row.name }}
                        <span v-if="row.course_id == 97" class="has-text-danger">
                            *Not required for Doctors with Psychiatry specialty
                        </span>

                    </td>
                    <td>{{ getValidityLabel(row.valid_for_months) }}</td>
                    
                    
                </tr>
                
                
            </tbody>
            
        </table>


       


        <div class="modal" :class="{'is-active': showAddModal === true}">
            <div class="modal-background" @click="closeAddModal()"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Add Course To Grade</p>
                    <button class="delete" aria-label="close" @click="closeAddModal()"></button>
                </header>
                <section class="modal-card-body">
                    <div class="notification is-info" v-if="coursesLoading === true">
                        Loading courses ...
                    </div>

                    <div class="field" v-if="coursesLoading === false">
                        <label class="label" for="course-filter">Filter courses</label>
                        <div class="control">
                            <input
                                id="course-filter"
                                class="input"
                                type="text"
                                v-model="courseFilterText"
                                placeholder="Type to filter courses ..."
                            >
                        </div>
                    </div>

                    <table class="table is-fullwidth is-hoverable" v-if="coursesLoading === false && filteredCourses.length > 0">
                        <thead>
                            <tr>
                                <th>Course</th>
                                <th>Validity (months)</th>
                                <th class="has-text-right">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in filteredCourses" :key="'course_' + row.id">
                                <td>{{ row.name }}</td>
                                <td>{{ row.valid_for_months }}</td>
                                <td class="has-text-right">
                                    <button
                                        class="button is-small is-success"
                                        @click="saveGradeCourse(row.id)"
                                        :disabled="savingCourse === true || isCourseAlreadyAdded(row.id)"
                                    >
                                        {{ isCourseAlreadyAdded(row.id) ? 'Added' : 'Add' }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="notification is-warning" v-if="coursesLoading === false && filteredCourses.length === 0">
                        No courses match your filter.
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="closeAddModal()" :disabled="savingCourse === true">Cancel</button>
                </footer>
            </div>
        </div>

       
    </div>
</template>

<script>

import UtilityService from '@/services/UtilityService.js';
import MemberMixin from '@/mixins/MemberMixin.js';



export default {
    
      name: 'GradeCourses',
        mixins: [MemberMixin],
        components: {
            
        },
        data: function () {
            return {
                member_search: '',
                grade_courses: [],
                   loading: false,
                   searchPerformed: false,
                   showModal: false,
                   order_by: 'name ASC',
                   accessToken: '',
                  grade_id:'',
                         grades: [],
                         courses: [],
                         coursesLoading: false,
                         courseFilterText: '',
                         showAddModal: false,
                         savingCourse: false,
                   
            }
        },
        methods: {
            async getGradeCourses()
            {
                this.loading = true
                if(this.grade_id != "" && this.grade_id != null)
                {
                    
                    UtilityService.getSimpleApiData(this.accessToken, "grade_courses/" + this.grade_id).then(
                        (response) => {
                            this.grade_courses = response 
                            this.loading = false
                            
                        }
                    );
                }
                else {
                    this.loading = false
                }

               
            },
            async getCourses()
            {
                this.coursesLoading = true

                UtilityService.getSimpleApiData(this.accessToken, "courses").then(
                    (response) => {
                        this.courses = response
                        this.coursesLoading = false
                    }
                ).catch(() => {
                    this.coursesLoading = false
                    alert("Something went wrong while loading courses")
                });
            },
            openAddModal()
            {
                if(this.grade_id == "" || this.grade_id == null)
                {
                    alert("Please select a grade first")
                    return
                }

                this.showAddModal = true
                this.courseFilterText = ''
                this.getCourses()
            },
            closeAddModal()
            {
                if(this.savingCourse === true)
                {
                    return
                }

                this.showAddModal = false
                this.courseFilterText = ''
            },
            isCourseAlreadyAdded(course_id)
            {
                return this.grade_courses.some((row) => {
                    return row.id == course_id || row.course_id == course_id
                })
            },
            getValidityLabel(valid_for_months)
            {
                if(valid_for_months == 0)
                {
                    return 'Once Only'
                }
                if(valid_for_months == 12)
                {
                    return 'Annually'
                }
                if(valid_for_months == 24)
                {
                    return '2 years'
                }
                if(valid_for_months == 36)
                {
                    return '3 years'
                }
                if(valid_for_months == 48)
                {
                    return '4 years'
                }

                return valid_for_months + ' months'
            },
            saveGradeCourse(course_id)
            {
                if(this.grade_id == "" || course_id == "")
                {
                    alert("Please select a grade and course")
                    return
                }

                this.savingCourse = true
                const formdata = {
                    grade_id: this.grade_id,
                    course_id: course_id
                }

                UtilityService.postSimpleApiData(this.accessToken, "grade_courses", formdata).then(
                    () => {
                        this.savingCourse = false
                        this.getGradeCourses()
                    }
                ).catch(() => {
                    this.savingCourse = false
                    alert("Something went wrong while adding course")
                });
            },
            
        },
        created() {
            this.getAccessToken()
                .then(() => { 
                    this.getGrades();
                    this.getGradeCourses();
                });
        
        },
        mounted() {
            
        },
        computed: {
            filteredCourses()
            {
                const filterText = (this.courseFilterText || '').toString().trim().toLowerCase()

                if(filterText === '')
                {
                    return this.courses
                }

                return this.courses.filter((row) => {
                    const courseName = (row.name || '').toString().toLowerCase()
                    const validForMonths = (row.valid_for_months || '').toString().toLowerCase()

                    return courseName.includes(filterText) || validForMonths.includes(filterText)
                })
            }
        }
       
    }
</script>